import { Chart as HighchartsChart } from '@highcharts/react/Highcharts.js';
import { useChartOptions } from './chart.utilities';
import Highcharts from './highcharts';
import type { HighchartsReactRefObject } from '@highcharts/react/Highcharts.js';
import type HighchartsLib from 'highcharts/es-modules/masters/highcharts.src.js';
import type { ComponentPropsWithoutRef, Ref } from 'react';

type HighchartsChartProps = ComponentPropsWithoutRef<typeof HighchartsChart>;

export type ChartProps = Omit<HighchartsChartProps, 'highcharts' | 'options'> & {
  onReady?: (chart: Highcharts.Chart) => void;
  options?: Highcharts.Options;
  ref?: Ref<HighchartsReactRefObject>;
};

/**
 * Renders a Highcharts React chart using Seeq's configured Highcharts runtime
 * and a simpler `onReady` callback in place of wiring `chart.events.load`
 * manually.
 */
export const Chart = ({ onReady, options, ref, ...rest }: ChartProps) => {
  const mergedOptions = useChartOptions({ options, onReady });

  return (
    <HighchartsChart
      {...rest}
      ref={ref}
      highcharts={Highcharts as unknown as typeof HighchartsLib}
      options={mergedOptions as HighchartsChartProps['options']}
    />
  );
};
